<script setup>
import { ref, computed, watch } from 'vue';
import { useQuasar } from 'quasar';
const $q = useQuasar();
const isLargeScreen = computed(() => $q.screen.gt.xs);
const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
  darkMode.value = newVal;
})

useSeoMeta({
  title: 'OnSight Optical - Optical Dispensary Management and Lab',
  description: 'OnSight Optical is an all-in-one optical dispensary management solution delivering exceptional eye care and long-term value to ophthalmology practices nationwide through our comprehensive optical dispensary services, cutting-edge technology, and expert guidance.',
})
</script>



<template>
    <div class="row justify-center" style="margin-top: 40px;">
        <q-img src="/img/FrameWide.jpg" alt="Frames" class="q-mx-lg" style="border-radius: 15px;" />
    </div>



    <div class="row justify-center" style="margin-top: 30px; margin-bottom: 20px;">
        <q-separator :color="darkMode ? 'grey-7' : 'brand'" size="4px" width="80%" />
    </div>

    <div class="q-px-lg q-col-gutter-lg row justify-center">
        <div class="col-12 col-md-4">
            <q-card :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-brand text-white'" style="height: 100%; border-radius: 15px">
                <q-card-section>
                    <div class="text-h3 text-center">Who We Are</div>
                    <div class="text-h4 text-center">&nbsp;</div>
                </q-card-section>
                <q-card-section>
                    <p style="font-size: 20px; text-align: center;">OnSight Optical is an all-in-one optical dispensary
                        management solution delivering exceptional eye care and long-term value to ophthalmology
                        practices nationwide through our comprehensive optical dispensary services, cutting-edge
                        technology, and expert guidance.</p>
                </q-card-section>
            </q-card>
        </div>
        <div class="col-12 col-md-4">
            <q-card :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-brand text-white'" style="height: 100%; border-radius: 15px">
                <q-card-section>
                    <div class="text-h3 text-center">Improving Patients Lives</div>
                    <div class="text-h4 text-center">&nbsp;</div>
                </q-card-section>
                <q-card-section>
                    <p style="font-size: 20px; text-align: center;">We believe the eye care exam is completed when
                        the patient has their prescription filled at the practice. By providing quality eyewear through
                        a seamless integration with OnSight Optical, the cycle of care is completed. Greater patient
                        satisfaction will result in practice referrals.</p>
                </q-card-section>
            </q-card>
        </div>
        <div class="col-12 col-md-4">
            <q-card :class="darkMode ? 'bg-grey-8 text-grey-4' : 'bg-brand text-white'" style="height: 100%; border-radius: 15px">
                <q-card-section>
                    <div class="text-h3 text-center">Management Theory</div>
                    <div class="text-h4 text-center">Discipline Creates Performance</div>
                </q-card-section>
                <q-card-section>
                    <p style="font-size: 20px; text-align: center;">OnSight Optical offers its partners the advantages
                        of a unique blend of
                        strategic, operational, technological, financial, and organizational benefits.</p>
                </q-card-section>
            </q-card>
        </div>
    </div>

    <div class="row justify-center" style="margin-top: 30px; margin-bottom: 20px;">
        <q-separator :color="darkMode ? 'grey-7' : 'brand'" size="4px" width="80%" />
    </div>

    <div>
        <div class="q-px-lg q-mb-lg q-col-gutter-lg row justify-center">
            <div class="col-12 col-md-6">
                <div :class="darkMode ? 'text-grey-5' : 'text-brand'">
                    <div class="text-h3 text-center">Management Solutions</div>
                    <div class="text-h4 text-center">&nbsp;</div>
                    <div>
                        <p style="font-size: 20px; text-align: left;">
                            OnSight Optical provides you, the physician with a completed optical dispensary. OnSight's
                            simple, easy to use, technologically advanced operations system enables you to compete
                            effectively and increase
                            patient satisfaction and practice revenues with minimal managerial overhead. OnSight Optical's
                            job is to
                            relieve you of all operational, merchandising, marketing and supervisory tasks with a
                            disciplined and
                            accountable system, so that your full attention may be focused solely on patient care.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div :class="darkMode ? 'text-grey-5' : 'text-brand'">
                    <div class="text-h3 text-center">Laboratory Solutions</div>
                    <div class="text-h4 text-center">&nbsp;</div>
                    <div>
                        <p style="font-size: 20px; text-align: left;">
                            OnSight Optical provides its practices with a state-of-the-art digital laboratory to produce
                            patients
                            lenses. We use cutting-edge technology for lens production and anti-reflective coatings. All of
                            this with
                            great turn-around time. Our optical lab is your customer service center. This is a difference
                            maker!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>



</template>

